import React from 'react';

import { IconProps } from './types';

export const WatchIconGreen = React.forwardRef<SVGSVGElement, IconProps>((props, forwardedRef) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15px"
    height="15px"
    viewBox="0 0 20 21.707"
    ref={forwardedRef}
    {...props}
  >
    <g id="watch_icons-01" data-name="watch icons-01" transform="translate(-62.523 -32.817)">
      <path
        id="Path_555"
        data-name="Path 555"
        d="M177,119.606l-2.362-2.365v-4.862a.758.758,0,0,0-1.516,0v5.174a.757.757,0,0,0,.222.536l2.588,2.588A.758.758,0,1,0,177,119.6Z"
        transform="translate(-101.374 -72.274)"
        fill="#6eb23f"
      />
      <path
        id="Path_556"
        data-name="Path 556"
        d="M64.275,39.286A8.871,8.871,0,0,1,69.6,35.526a.545.545,0,0,0,.339-.821,4.014,4.014,0,1,0-6.549,4.621.542.542,0,0,0,.45.206A.55.55,0,0,0,64.275,39.286Z"
        fill="#6eb23f"
      />
      <path
        id="Path_557"
        data-name="Path 557"
        d="M216.652,32.841a4.007,4.007,0,0,0-3.393,1.871.549.549,0,0,0-.044.5.543.543,0,0,0,.381.325,8.865,8.865,0,0,1,5.352,3.732.548.548,0,0,0,.889.031,4.013,4.013,0,0,0-3.186-6.458Z"
        transform="translate(-138.145 -0.021)"
        fill="#6eb23f"
      />
      <path
        id="Path_558"
        data-name="Path 558"
        d="M87.2,86.581a9.244,9.244,0,1,0-13.208,0l-.7.979a1.11,1.11,0,0,0,1.81,1.284l.619-.873a9.276,9.276,0,0,0,9.745,0l.62.872A1.109,1.109,0,0,0,87.9,87.56ZM72.846,80.118A7.755,7.755,0,1,1,80.6,87.864a7.75,7.75,0,0,1-7.754-7.745Z"
        transform="translate(-8.079 -34.83)"
        fill="#6eb23f"
      />
    </g>
  </svg>
));
WatchIconGreen.displayName = 'WatchIconGreen';

export default WatchIconGreen;
